
/* eslint-disable @typescript-eslint/camelcase */
import { defineComponent, onMounted, watch } from "vue";
import {
  messageListener,
  fetchMessages,
  allMessages
} from "@/vuetils/useMessage";
import { fetchUsers, allUsers } from "@/vuetils/useUser";
import { currentChannel } from "@/vuetils/useChannel";
export default defineComponent({
  name: "Messages",
  async setup() {
    onMounted(() => {
      messageListener.subscribe();
    });

    // fetch all messages for selected channel
    watch(
      () => currentChannel.value,
      selectedChannel => {
        fetchMessages(selectedChannel);
      }
    );
    // Need users before we can display message as message IDs are mapped to usernames
    await fetchUsers();
    await fetchMessages(currentChannel.value);
    return { allMessages, allUsers };
  }
});
